import anylogger from '@app/anylogger'
import { useCurrentRef } from '@app/hooks'
import { Box } from '@mui/material'
import React from 'react'

const log = anylogger('Image')

interface ImageProps {}
export const Image = React.forwardRef(function Image(props: any, passedRef: any) {
	let { src, width, height, m, sx, ...rest } = props
	if (!m) m = '0.5em'
	const [ref, setRef] = useCurrentRef<HTMLElement>(passedRef)

	return <Box ref={setRef} component="img" src={src} width={width} height={height} m={m} sx={{ ...sx }} {...rest}></Box>
})
